import { useAppSelector } from 'src/hooks';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';

export const SiteSessionWrapper = ({ children }) => {
  const account = useAppSelector(accountSelector);

  if (!account) return <></>;

  return <>{children}</>;
};
